<template>
  <div :class="getClasses">
    <router-link :to="{ name: 'Team Member', params: { slug: content.post_name }}">
      <img  class="greyscale" :alt="`${content.post_title} portrait`" :data-src="image" />
      <div v-if="content.details">
        <h3 class="caps mb0 mt1" v-html="preventWidows(content.post_title)" />
        <h4 class="red mb0 fs-s" v-html="preventWidows(content.details.role)" />
        <div class="px3 fs-s mt1" v-if="showDetails">
          <span class="block mx-auto" v-html="preventWidows(content.short_description)"></span>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {

  name: 'PersonPreview',

  data () {
    return {

    }
  },

  computed: {
    getClasses () {
      return `person col col-12 pb3 center ${this.classes}`
    },
    image () {
      if (this.content.details && this.content.details.image.hasOwnProperty('sizes')) {
        if (this.content.details.image.sizes.thumbnail) {
          return this.content.details.image.sizes.thumbnail
        } else {
          return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mO89R8AArkB2ygWfsQAAAAASUVORK5CYII='
        }
      } else {
        return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mO89R8AArkB2ygWfsQAAAAASUVORK5CYII='
      }
    }
  },

  props: ['content', 'showDetails', 'classes']

}
</script>

<style lang="css" scoped>
  div.person {
    img {
      width: 25%;
      max-width: 100px;
      border-radius: 60%;
    }

    .image-placeholder {
      width: 25%;
    }

    span {
      max-width: 350px;
    }
  }
</style>
